import { ConversationInfo } from '../../client/components/common/conversation/fragments'

export const ConversationInfoFragment = ConversationInfo
